interface PropsI {
    className?: string;
    color?: string;
    backgroundColor?: string;
    size?: "lg"|"md"|"sm" ;
}

export default function LoadingSpinner({backgroundColor, color, className, size}:PropsI){
    return (
        <div className={`loading-spinner 
            ${size && size === 'lg'? ' loading-spinner-lg' : size && size === 'md' ? 'loading-spinner-md' : 'loading-spinner-sm'} 
            ${className}`}
             style={{
                 borderTopColor: color ? color : undefined,
                 borderColor: backgroundColor ? backgroundColor : undefined
             }}>
        </div>
    )
}